import { InvoiceDetailsHeader } from './components/invoiceDetailsHeader';

export const InvoiceDetails = () => {
  return <InvoiceDetailsHeader />;
};
